import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
import { IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { useState } from 'vuex-composition-helpers';
import { IHotel } from '@entities/hotel';
import { initBackboneConnectionFiltersHotels } from '@features/hotel/filterHotels';
import { initFilterBudgetBackboneVuex } from '@features/filterByBudget';
import { computed, unref } from 'vue';

export default function () {
    initBackboneConnectionFiltersHotels();
    initFilterBudgetBackboneVuex();

    const {
        touristGroup,
        syncHotels,
        filteredHotels,
        isPopularityFilterActive,
        filteredHotelsWithoutRestType,
        filteredHotelsWithoutPrice,
        filteredHotelsWithoutBeachType,
        filteredHotelsWithoutRenovations,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, [
        'touristGroup',
        'syncHotels',
        'filteredHotels',
        'isPopularityFilterActive',
        'filteredHotelsWithoutRestType',
        'filteredHotelsWithoutPrice',
        'filteredHotelsWithoutBeachType',
        'filteredHotelsWithoutRenovations',
    ]);

    const hotelOfferProductsPrices = computed(() => unref(filteredHotelsWithoutPrice).map((hotel) => hotel.minPrice));

    return {
        filteredHotelsWithoutBeachType,
        filteredHotelsWithoutRestType,
        touristGroup,
        syncHotels,
        filteredHotels,
        isPopularityFilterActive,
        filteredHotelsWithoutRenovations,
        hotelOfferProductsPrices,
    };
}